import manifest from "../generated/image-manifest.json";

// Native srcset selection: no browser-side resizing or extra image requests.
export function responsiveImage(name: keyof typeof manifest, sizes: string) {
  const image = manifest[name];
  const url = (file: string) =>
    `${process.env.PUBLIC_URL || ""}/responsive-images/${file}`;
  const fallback =
    image.variants.find((variant) => variant.width >= 800) ||
    image.variants[image.variants.length - 1];
  return {
    src: url(fallback.file),
    srcSet: image.variants
      .map((variant) => `${url(variant.file)} ${variant.width}w`)
      .join(", "),
    sizes,
    width: image.width,
    height: image.height,
  };
}
